
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SecurityOverrideDialog extends SiteEntityDialog<SecurityOverrideRow, any> {
        protected getFormKey() { return SecurityOverrideForm.formKey; }
        protected getIdProperty() { return SecurityOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityOverrideRow.localTextPrefix; }
        protected getNameProperty() { return SecurityOverrideRow.nameProperty; }
        protected getService() { return SecurityOverrideService.baseUrl; }

        protected form = new SecurityOverrideForm(this.idPrefix);

    }
}